import React from "react";
//*import PropTypes from 'prop-types';
import "./meetingGridSkeleton.scss";
import { URLineSkeleton } from "./skeletonWidgets/lineSkeleton";
export default function URmeetGridSkeleton(props: any) {
  return (
    <>
      <div className="skeletonLoading">
        <div className="meetinggridSkeleton">
          <div className="detailsList">
            <URLineSkeleton className='line line8 size65'/>
            <URLineSkeleton className='line lineThin size65'/>
          </div>
           <div className="detailscenter">
              <URLineSkeleton className='line line5 size45 mt-0'/>
              <URLineSkeleton className='line line3 size2 mt-0'/>
              <URLineSkeleton className='line lineThick size30 mt-0'/>
          </div>
          <div className="detailscenter">
              <URLineSkeleton className='line line15 size45 '/>
              <URLineSkeleton className='line line15 size30 '/>
          </div>
        </div>
       
      </div>
    </>

  );
}

